export default "__VITE_ASSET__DWzMYhR$__"